<div
  class="keyword-search"
  [ngClass]="[!showSearchBtn ? 'keyboard-search-with-search-button' : 'keyboard-search-without-search-button']"
  #locationSuggestionsContainer
>
  <span class="keyword-search-icon">
    <svg viewBox="0 0 18 19" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.7505 16.7591L16.7556 17.754C16.4286 18.0845 15.8942 18.0845 15.5638 17.754L12.0587 14.2489C11.9005 14.0907 11.8126 13.8763 11.8126 13.6512C11.8126 13.4184 11.5418 13.2845 11.3478 13.4132C10.1914 14.1797 8.80489 14.6251 7.31254 14.6251C3.27305 14.6251 0 11.352 0 7.31254C0 3.27305 3.27305 0 7.31254 0C11.352 0 14.6251 3.27305 14.6251 7.31254C14.6251 8.80489 14.1797 10.1914 13.4132 11.3478C13.2845 11.5418 13.4184 11.8126 13.6512 11.8126C13.8763 11.8126 14.0907 11.9005 14.2489 12.0587L17.754 15.5638C18.081 15.8942 18.081 16.4286 17.7505 16.7591ZM2.81252 7.31253C2.81252 9.8016 4.82697 11.8126 7.31254 11.8126C9.80161 11.8126 11.8126 9.7981 11.8126 7.31253C11.8126 4.82346 9.79811 2.8125 7.31254 2.8125C4.82347 2.8125 2.81252 4.82696 2.81252 7.31253Z"
      />
    </svg>
  </span>
  <input
    maxlength="80"
    data-nav-type="find a location"
    data-nav-element="fal search text"
    data-nav-location="fal search initiation"
    type="text"
    [(ngModel)]="searchTerm"
    (ngModelChange)="onInputChange($event)"
    [placeholder]="searchPlaceholder"
    aria-owns="vTypeahead"
    (keyup.enter)="handleKeywordChange()"
    (keyup.escape)="setAutocompleteActive(false)"
    (keydown)="keyDownHandler($event)"
    #search
    data-testid="search-term-input"
    [class.input-new]="!showSearchBtn"
    [class.input-new-error]="showError()"
    (blur)="onFocusLost($event)"
    role="combobox"
    aria-autocomplete="list"
    [attr.aria-expanded]="autocompleteActive"
    [attr.aria-busy]="inputInFocus && loadSpinnerSuggestions && searchTerm !== '' && !autocompleteActive"
    (focus)="onFocusGained()"
    tabindex="0"
  />
  <p class="p2 error-message" *ngIf="showError()">Please select an option from the dropdown</p>

  <ul
    *ngIf="inputInFocus && loadSpinnerSuggestions && searchTerm !== ''"
    class="location-suggestions-container keyword-suggestions-container-scroll"
    [attr.aria-label]="loadSuggestions"
  >
    <li class="service-list" *ngIf="!hasSuggestions() && loadSpinnerSuggestions">
      <div class="loadSpinner">
        <p role="alert">{{loadSuggestions}}</p>
      </div>
    </li>
  </ul>
  <ul
    *ngIf="inputInFocus && autocompleteActive && searchTerm !== ''"
    aria-label="Location Service Keywords Results are available"
    role="list"
    class="location-suggestions-container keyword-suggestions-container-scroll"
  >
    <li class="locations-list" *ngIf="suggestions.locations && suggestions.locations.length > 0">
      <p>Locations</p>
      <ul>
        <li
          class="p p2"
          *ngFor="let location of suggestions.locations.slice(0,locationSliceIndex); let i = index"
          (click)="locationClick(location)"
          (keyup.enter)="locationClick(location)"
          [innerHTML]="queryHighlight(location.name)"
          [falFocused]="activeLocationDropdownIndex === i"
          [class.focused]="activeLocationDropdownIndex === i"
          [attr.aria-selected]="activeLocationDropdownIndex === i"
          [ngClass]="{ selected: activeLocationDropdownIndex === i }"
          (mouseenter)="handleMouseEnter(i, 'location')"
          [attr.aria-label]="location"
          tabindex="0"
        ></li>
      </ul>
      <div class="show-more-less" *ngIf="suggestions.locations.length > defaultSuggestionCount">
        <a
          href="javascript:;"
          [attr.aria-label]=" locationSliceIndex < suggestions.locations.length  ? 'Show more locations' : 'Show less locations'"
          (mouseenter)="seeLessMoreHover('location')"
          (click)="expandLessClick('location')"
          #locationSeeMore
        >
          {{ locationSliceIndex < suggestions.locations.length ? 'More' : 'Less' }}
          <svg
            class="more-arrow"
            [ngClass]="{ 'less-arrow': locationSliceIndex === suggestions.locations.length }"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M1 1L6 6L11 1" />
          </svg>
        </a>
      </div>
    </li>
    <li class="service-list" *ngIf="suggestions.services && suggestions.services.length >0">
      <p>Services</p>
      <ul>
        <li
          class="p p2"
          *ngFor="let service of suggestions.services.slice(0,serviceSliceIndex); let j = index"
          (click)="dropdownClick(service)"
          (keyup.enter)="dropdownClick(service)"
          [innerHTML]="queryHighlight(service.name)"
          [falFocused]="activeServiceDropdownIndex === j"
          [class.focused]="activeServiceDropdownIndex === j"
          [attr.aria-selected]="activeServiceDropdownIndex === j"
          [ngClass]="{ selected: activeServiceDropdownIndex === j }"
          (mouseenter)="handleMouseEnter(j, 'services')"
          [attr.aria-label]="service"
          tabindex="0"
        ></li>
      </ul>
      <div class="show-more-less" *ngIf="defaultSuggestionCount < suggestions.services.length">
        <a
          href="javascript:;"
          [attr.aria-label]=" serviceSliceIndex < suggestions.services.length  ? 'Show more services' : 'Show less services'"
          data-type="viewMore"
          (mouseenter)="seeLessMoreHover('services')"
          (click)="expandLessClick('services')"
          #servicesSeeMore
        >
          {{ serviceSliceIndex < suggestions.services.length ? 'More' : 'Less' }}
          <svg
            class="more-arrow"
            [ngClass]="{ 'less-arrow': serviceSliceIndex === suggestions.services.length }"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M1 1L6 6L11 1" />
          </svg>
        </a>
        <br />
      </div>
    </li>
    <li class="keyword-list keyword-search-list" *ngIf="suggestions.keywords && suggestions.keywords.length > 0">
      <p>Keywords</p>
      <ul>
        <li
          class="p p2"
          *ngFor="let keyword of suggestions.keywords.slice(0,keywordSliceIndex); let j = index"
          (click)="dropdownClick(keyword)"
          (keyup.enter)="dropdownClick(keyword)"
          [innerHTML]="queryHighlight(keyword.name)"
          [falFocused]="activeKeywordDropdownIndex === j"
          [class.focused]="activeKeywordDropdownIndex === j"
          [attr.aria-selected]="activeKeywordDropdownIndex === j"
          [ngClass]="{ selected: activeKeywordDropdownIndex === j }"
          (mouseenter)="handleMouseEnter(j, 'keywords')"
          [attr.aria-label]="keyword"
          tabindex="0"
        ></li>
      </ul>
      <div class="show-more-less" *ngIf="defaultSuggestionCount < suggestions.keywords.length">
        <a
          href="javascript:;"
          [attr.aria-label]=" keywordSliceIndex < suggestions.keywords.length  ? 'Show more keywords' : 'Show less keywords'"
          data-type="viewMore"
          (mouseenter)="seeLessMoreHover('keywords')"
          (click)="expandLessClick('keywords')"
          #keywordsSeeMore
        >
          {{ keywordSliceIndex < suggestions.keywords.length ? 'More' : 'Less' }}
          <svg
            class="more-arrow"
            [ngClass]="{ 'less-arrow': keywordSliceIndex === suggestions.keywords.length }"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M1 1L6 6L11 1" />
          </svg>
        </a>
        <br />
      </div>
    </li>
    <li class="service-list" *ngIf="!hasSuggestions() && !loadSpinnerSuggestions">
      <div class="No-result-found">
        <span>
          <svg
            data-icon="exclamation-circle"
            class="svg-inline--fa fa-exclamation-circle fa-w-16"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
          >
            <path
              fill="currentColor"
              d="M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
            ></path>
          </svg>
        </span>
        <p role="alert">No Results Found</p>
      </div>
    </li>
  </ul>
  <span class="error-icon" *ngIf="showError()">
    <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="10" fill="#FF0000" />
      <text x="10" y="14" font-family="Arial, sans-serif" font-size="12" font-weight="bold" text-anchor="middle" fill="#FFFFFF">!</text>
    </svg>
  </span>
</div>
